<template>
    <div id="nsw-search">
        <!--header-->
        <header class="search-nav">

            <div class="right-menu">
                <div class="right-menu-btn" tooltip="Back" flow="down" onclick="window.history.go(-1); return false;">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path d="M68.004,50.015C68,38.024,61.998,32.029,50,32.029H34V52L2,27L34,2v20.029h16
	c18.662,0,27.995,9.328,28,27.985C77.996,68.672,69.328,78,52,78H22V68h30C62.665,68,68,62.005,68.004,50.015L68.004,50.015z"></path>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="search-bar">
                <input v-on:keyup.enter="beginSearch()" v-model="search_value" type="text" id="search-bar" :placeholder="$t('Search')+'...'" name="search">
                <button type="submit" tooltip="Search" flow="down" v-on:click="beginSearch()">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path d="M57.9644994,50.7081812 L80,72.8167282 L72.8288188,80 L50.7090618,57.9638637 C45.4473964,61.7619702 38.9850581,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C49.673112,0 64,14.326888 64,32 C64,38.9846685 61.7622199,45.4466754 57.9644994,50.7081812 Z M32,54 C44.1502645,54 54,44.1502645 54,32 C54,19.8497355 44.1502645,10 32,10 C19.8497355,10 10,19.8497355 10,32 C10,44.1502645 19.8497355,54 32,54 Z"></path>
                        </svg>
                    </div>
                </button>
            </div>

        </header>
        <!--end header-->

        <!--row-path-->
        <div class="row-path">
            <!--left side-->
            <ul class="path">
                <li>
                    <a href="javascript:void(0)" class="path-search"></a>
                </li>
                <li>{{title}}</li>
            </ul>
            <!--right side-->
            <div class="row-path-right">
                <template v-if="searched_value">
                    <div class="search-result">{{ lang($t("Total %total_resources% Resource(s)"),{total_resources: total_resources} ) }}</div>
                </template>
            </div>
        </div>
        <!--end row-path-->

        <!--content wrapper-->
        <div class="content-wrapper resources">
            <template v-if="searched_value">
                <div class="obj-resources-table">
                    <!--tbody-->
                    <div class="tbody">

                        <div class="tr no-border">
                                <template v-if="total_resources > 0">
                                    <div class="td no-border">
                                        <input type="checkbox" name="select_all_btn" id="head" value="option1" v-model="selectAllStatus" @click="selectAll">
                                        <label class="pull-right text" for="head"><span class="text-secondary"></span></label>
                                    </div>
                                </template>
                            <div class="td no-border">
                                <h3>{{ lang($t("%total_resources% match result(s) about %searched_value%"),{total_resources: total_resources, searched_value: searched_value} ) }}</h3>
                            </div>
                        </div>

                        <template v-if="total_resources > 0">
                            <div class="tr" v-for="(item, key) in result_list">
                                        <template v-if="item.technical.size > 0">
                                            <div class="td">
                                                <HkepCheckBox
                                                        v-bind:inputId="key"
                                                        v-bind:inputValue="key"
                                                        v-bind:isDisabled="item.allow_download"
                                                        v-bind:isChecked="item.check"
                                                        v-bind:size="item.technical.size"
                                                        v-on:click.native="toggleCheck(item, key)"

                                                ></HkepCheckBox>
                                                <HkepLabel
                                                        v-bind:labelFor="key"
                                                        v-bind:size="item.technical.size"
                                                ></HkepLabel>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="td"></div>
                                        </template>
                                        <!--<div class="td" style="width: 20px;"> {{ key+1 }}.</div>-->
                                        <div class="td" style="width: 100%;">
                                            <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                            <template v-for="entry in searchResultEntry">
                                                <p v-if="getSearchData(item, entry.filter)!=''">{{`${entry.title}  ${getSearchData(item, entry.filter)}`}}</p>
                                            </template>

                                            <template v-if="checkHasThumbnail(item)">
                                                <hkep-thumbnail
                                                        v-bind:url="getThumbnailUrl(item)"
                                                        v-bind:image="getThumbnailImage(item)"
                                                        v-bind:item="item"
                                                    >

                                                </hkep-thumbnail>
                                            </template>
                                            <!--<template v-if="
                                            specialDisplay() == 'csdsenior-c' ||
                                            specialDisplay() == 'csdnewjourney'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="getClassificationDisplayName(item, 0)">
                                                    <p>主題：{{ getClassificationDisplayName(item, 0) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>課題：{{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                                <template v-if="item.educational.description">
                                                    <p>學習重點：{{ item.educational.description }}</p>
                                                </template>
                                            </template>
                                            <template v-else-if="specialDisplay() == 'csdsenior-e'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="getClassificationDisplayName(item, 0)">
                                                    <p>Theme: {{ getClassificationDisplayName(item, 0) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>Topic: {{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                                <template v-if="item.educational.description">
                                                    <p>Learning Focus: {{ item.educational.description }}</p>
                                                </template>
                                            </template>
                                            <template v-else-if="specialDisplay() == 'seniorchi-tg-promo'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="item.general.description">
                                                    <p>說明：{{ item.general.description }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 0)">
                                                    <p>範疇：{{ getClassificationDisplayName(item, 0) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>資源分類：{{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                            </template>
                                            <template v-else-if="specialDisplay() == 'jrchi-tg-promo'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="item.general.description">
                                                    <p>說明：{{ item.general.description }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>年級：{{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 2)">
                                                    <p>分冊：{{ getClassificationDisplayName(item, 2) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 3)">
                                                    <p>單元：{{ getClassificationDisplayName(item, 3) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 4)">
                                                    <p>單元名稱：{{ getClassificationDisplayName(item, 4) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 5)">
                                                    <p>篇章：{{ getClassificationDisplayName(item, 5) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 6)">
                                                    <p>項目：{{ getClassificationDisplayName(item, 6) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 7)">
                                                    <p>範疇：{{ getClassificationDisplayName(item, 7) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 8)">
                                                    <p>資源分類：{{ getClassificationDisplayName(item, 8) }}</p>
                                                </template>
                                            </template>
                                            <template v-else-if="
                                            specialDisplay() == 'jrchi-tg' ||
                                            specialDisplay() == 'jrchi-sb'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="item.general.description">
                                                    <p>說明：{{ item.general.description }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 0)">
                                                    <p>年級：{{ getClassificationDisplayName(item, 0) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>分冊：{{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 2)">
                                                    <p>單元：{{ getClassificationDisplayName(item, 2) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 3)">
                                                    <p>單元名稱：{{ getClassificationDisplayName(item, 3) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 4)">
                                                    <p>篇章：{{ getClassificationDisplayName(item, 4) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 5)">
                                                    <p>範疇：{{ getClassificationDisplayName(item, 5) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 6)">
                                                    <p>資源分類：{{ getClassificationDisplayName(item, 6) }}</p>
                                                </template>
                                            </template>
                                            <template v-else-if="
                                            specialDisplay() == 'seniorchi-tg' ||
                                            specialDisplay() == 'seniorchi-sb'">
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="item.general.description">
                                                    <p>說明：{{ item.general.description }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 0)">
                                                    <p>單元：{{ getClassificationDisplayName(item, 0) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 1)">
                                                    <p>篇章：{{ getClassificationDisplayName(item, 1) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 2)">
                                                    <p>範疇：{{ getClassificationDisplayName(item, 2) }}</p>
                                                </template>
                                                <template v-if="getClassificationDisplayName(item, 3)">
                                                    <p>資源分類：{{ getClassificationDisplayName(item, 3) }}</p>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <p>{{ (item.general.title)? item.general.title: "" }}</p>
                                                <template v-if="item.general.coverage">
                                                    <p>{{ item.general.coverage }}</p>
                                                </template>
                                                <template v-if="item.general.description">
                                                    <p>{{ item.general.description }}</p>
                                                </template>
                                            </template>
                                            <template v-if="checkHasThumbnail(item)">
                                                <hkep-thumbnail
                                                    v-bind:url="getThumbnailUrl(item)"
                                                    v-bind:image="getThumbnailImage(item)"
                                                    v-bind:item="item"
                                                ></hkep-thumbnail>
                                            </template>-->
                                        </div>

                                        <div class="td">
                                            <HkepDisplayFormatSize
                                                    v-bind:url="getFileApi+item.id.uri"
                                                    v-bind:fileType="getFileType(item.technical.format)"
                                                    v-bind:size="item.technical.size"
                                                    v-bind:resource_url="getUrl(item, 'hkep-url')"
                                                    v-bind:filename="item.technical.filename"
                                                    v-bind:id="item.id.uri"
                                                    v-bind:preview_url="getPreviewFileApi+item.id.uri"
                                                    v-bind:has_preview="checkHasPreview(item, 'hkep-preview-url')"
                                                    v-bind:item="item"
                                            ></HkepDisplayFormatSize>
                                        </div>
                                    </div>

                        </template>
                        <template v-else>
                            <div class="tr no-border">
                                <div class="td no-border">
                                    <div style="text-align: center">{{ lang($t("No match result")) }}</div>
                                </div>
                            </div>
                        </template>

                    </div>
                    <!---end tbody-->
                </div>
            </template>

        </div>
        <!--end content wrapper-->

        <subcate-footer></subcate-footer>

    </div>


</template>

<script>
    import api from '@js/api';
    import {common} from "@mixins/common";
    import mime_type from '@json/mime_type'
    import HkepDisplayFormatSize from '@/HkepDisplayFormatSize';
    import EventBus from '@common/eventBus';
    import Vue from 'vue';
    import axios from 'axios';
    import HkepCheckBox from '@/HkepCheckBox';
    import HkepLabel from '@/HkepLabel';
    import XAPIJS from "xapijs";
    import HkepThumbnail from "./HkepThumbnail";
    import {nsw_common} from "@mixins/nsw_common";

    export default {
        name: "NswSearch",
        mixins:[common],
        components: {
            HkepThumbnail,
            HkepDisplayFormatSize,
            HkepCheckBox,
            HkepLabel
        },

        data() {

            return {
                total_resources: 0,
                title: "搜尋",
                search_value: "",
                result_list: [],
                searched_value: "",
                getFileApi: getFileApi,
                selectAllStatus: false,
                getPreviewFileApi: getPreviewFileApi,
                content_header_list: [],
                skip: 0,
                limit: 50,
                searchResultEntry: []
            }

        },
        beforeRouteEnter (to, from, next) {
            next(vm=>{
                EventBus.$emit("showGlobalLoading");

                //TODO: check if logged in, if not logged in, don't get download data
                Promise.all(
                    [
                        api.getMainCate(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate) => {
                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }

                        //TODO: Handle MathJax in common  place, e.g. mixins
                        Vue.nextTick(()=>{
                            if(window.MathJax) {
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
                                    EventBus.$emit("hideGlobalLoading");
                                });
                            }
                        });

                    }))
                /*.catch(error=>{
                    //Handle errors here if something is expected to precess here
                });
                */
            })

        },
        methods: {
            specialDisplay()
            {
                return window.urlData.subjectCompo;
            },
            getThumbnailImage(item)
            {
                return nsw_common.getThumbnailImage(item);
            },
            getThumbnailUrl(item)
            {
                return nsw_common.getThumbnailUrl(item);
            },
            getClassificationDisplayName(item, filter_key)
            {
                let name = ""


                if (item.classifications) {
                    item.classifications.forEach(function(classi) {
                        if (classi.purpose.uri === filter_key) {
                            if (classi.taxon_path) {
                                name = classi.taxon_path.terms.term.txt;
                            }
                        }

                    });
                }
                return name;
            },
            checkHasThumbnail(item)
            {
                let result = false;

                if (item.technical) {
                    if (item.technical.location) {
                        item.technical.location.forEach(function(item2) {
                            if (item2.uri) {
                                if (item2.uri.includes("hkep-thumbnail")) {
                                    result = true;
                                }
                            }
                        });
                    }
                }

                return result;
            },
            selectAll()
            {
                let self = this;

                this.selectAllStatus = !this.selectAllStatus;
                this.result_list.forEach(function(item) {
                    self.toggleCheck(item);
                });
            },
            toggleCheck: function(item, index) {
                if ( item.size > 0 && item.allow_download) {
                    if (!item.check) {
                        Vue.set(item, 'check', true);
                        this.$store.commit("resource_store/add", item);
                    } else {
                        Vue.set(item, 'check', false);
                        this.$store.commit("resource_store/remove", item);
                    }
                }
            },
            getUrl(item, skey)
            {
                var url = "";

                if (item.technical) {
                    if (item.technical.location) {

                        Object.keys(item.technical.location).forEach(function(key) {

                            if (item.technical.location[key].uri) {
                                var arr_uri = item.technical.location[key].uri.split(":");
                                if (arr_uri[0] === skey) {
                                    url = arr_uri[1];
                                    url = url.replace("|", ":");
                                }
                            }

                        });

                    }
                }

                return url;
            },
            checkHasPreview(item, search_key)
            {

                var result = false;

                if (item.technical) {
                    if (item.technical.location) {

                        Object.keys(item.technical.location).forEach(function(key) {

                            if (item.technical.location[key].uri) {
                                var arr_uri = item.technical.location[key].uri.split(":");
                                if (arr_uri[0] === search_key) {
                                    result = true;
                                }
                            }

                        });

                    }
                }

                return result;


            },
            beginSearch(clearResult = true)
            {

                let self = this;

                if (clearResult) {
                    self.clearResult();
                }

                self.searched_value = self.search_value;

                if (this.search_value) {
                    EventBus.$emit("showGlobalLoading");

                    api.searchFrontend(this.search_value, self.skip, self.limit).then(function(resp) {
                        if (resp.data) {
                            self.total_resources = resp.data.total;
                            resp.data.resource.forEach(function(obj, key) {
                                obj.metadata_id = obj.id.uri;
                                obj.size = obj.technical.size;
                                obj.row = key;
                                obj.check = false;
                                self.result_list.push(obj);
                            });
                        }

                        EventBus.$emit("hideGlobalLoading");


                    }).catch(error => {
                        EventBus.$emit("hideGlobalLoading");

                    });


                    let xapijs = new XAPIJS(xapi_config, access_token);

                    xapijs.experienced(
                        display_name,
                        membercode,
                        window.location.href,
                        "搜尋"
                    );

                }
            },
            getFileType(mimeType)
            {
                return mime_type[mimeType];
            },
            clearResult() {
                this.total_resources = 0;
                this.result_list = [];
                this.searched_value = "";
                this.skip = 0;
            },
            formatUri(uri) {
                return uri.split(":")[1].replace("|", ":")
            },
            getSearchData(lom, filter) {

                let uri_key = nsw_common.getUriKey(filter);
                let result = "";

                if (uri_key === "hkep-filter") {
                    result = this.getClassificationDisplayName(lom, filter);
                } else if (uri_key === "hkepc") {

                    if (Object.keys(lom).length > 0) {
                        let uri_value = nsw_common.getUriValue(filter);
                        let lom_path = uri_value.split("/");

                        if (lom_path.length === 1) {
                            if (lom[lom_path[0]]) {
                                result = lom[lom_path[0]];
                            }
                        } else if (lom_path.length === 2) {

                            if (typeof lom[lom_path[0]] [lom_path[1]] !== 'undefined') {
                                result = lom[lom_path[0]] [lom_path[1]];
                            }
                        } else if (lom_path.length === 3) {
                            if (lom[lom_path[0]][lom_path[1]][lom_path[2]]) {
                                result = lom[lom_path[0]][lom_path[1]][lom_path[2]];
                            }
                        }
                    }

                }

                return (result !== "" && result !== null) ? result: "";


            }
        },
        beforeMount() {
            api.getSearchResultEntryFrontend().then(res => {
                this.searchResultEntry = res.data
            })
        },
        mounted() {
            let self = this;

            var keyword = this.$route.query.keyword;
            if (keyword) {
                self.search_value = keyword;
                self.beginSearch();
            }

            jQuery("#app").on("scroll", function (event) {

                if(jQuery(this).scrollTop() + jQuery(this).innerHeight() >= jQuery(this)[0].scrollHeight) {
                    self.skip = self.skip+50;
                    self.beginSearch(false);
                }

            });

            EventBus.$on('unselect_all_subcate', ()=> {
                this.selectAllStatus = false;

                if (self.result_list) {
                    self.result_list.forEach(function(item) {
                        Vue.set(item, 'check', false);

                    });
                }
            });
        }

    }


</script>
<style>
    header.logged-in { display: none;}
    .right-menu {
        float: right;
        padding: 0.75rem 1.5rem;
        display: inline-block;
    }

</style>
<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";
    @import "~@sass/row-path.scss";

    .row-path {
        background: none;
    }
    /*search*/
    header.search-nav{width:100%;height:3.5rem;padding:0;display:inline-flex;}
    header.search-nav .right-menu{float:left;flex-grow:0; width: unset;}
    header.search-nav .right-menu-btn{margin:0;}
    header.search-nav .search-bar{
        @extend %border-primary;
        @extend %bg-secondary;
        flex-grow:1;
        margin:0.75rem 1.5rem 0.75rem 0;
        height:2rem;
        display:inline-flex;
        -webkit-radius:6px;
        -moz-border-radiust:6px;
        border-radius:6px;}
    header.search-nav .search-bar input[type=text]{
        padding:0 1rem;
        font-size:1rem;
        border:0;
        float:left;
        width:100%;
        background:none;
        height:2rem;
        @extend %text-secondary;
        -webkit-radius:6px 0 0 6px;
        -moz-border-radiust:6px 0 0 6px;
        border-radius:6px 0 0 6px;
    }
    header.search-nav .search-bar input::placeholder{@extend %text-secondary;}
    header.search-nav .search-bar button{
        float:left;width:5rem;
        @extend %btn-primary;
        cursor:pointer;
        @extend %border-primary;
        height:100%;
        -webkit-radius:0 6px 6px 0;
        -moz-border-radiust:0 6px 6px 0;
        border-radius:0 6px 6px 0;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }
    header.search-nav .search-bar button:hover{@extend %btn-primary-hover;}
    header.search-nav .search-bar::after{content:"";clear:both;display:table;}

    /*fix chrome auto yello background*/
    .search-bar input:-webkit-autofill {-webkit-box-shadow:inset 0 0 0px 9999px #005b99;}
    .search-bar input:-webkit-autofill,
    .search-bar input:-webkit-autofill:hover,
    .search-bar input:-webkit-autofill:focus{-webkit-text-fill-color:#fff;}

    header.search-nav .search-bar button div{width:1rem;height:1rem;margin:0.5rem auto;}
    header.search-nav .search-bar button svg{fill:#fff;}


    @media screen and (max-width:767px){
        header.search-nav{position:fixed;z-index:90;}
        header.search-nav .search-bar{margin:.5rem .5rem .5rem 0;height:2.5rem;}
        header.search-nav .search-bar button div{width:1.25rem;height:1.25rem;}
        header.search-nav .search-bar input[type=text]{height:100%;}
        header.search-nav .right-menu{padding:0;}
        header.search-nav .right-menu-btn{width:2.5rem;height:2.5rem;margin:.5rem;padding:0;
            -webkit-transition: all 0s ease-in-out;
            -moz-transition: all 0s ease-in-out;
            -o-transition: all 0s ease-in-out;
            transition: all 0s ease-in-out;}
        header.search-nav .right-menu-btn div{width:1.5rem;height:1.5rem;margin:0.5rem;}
    }

    .td.no-border {
        border: 0 !important;
        cursor: default;
        background: none !important;
        border-left: 0 !important;
    }


    .tr.no-border:hover {
        box-shadow: unset !important;
        border-left: 0 !important;
    }

    .obj-resources-table .tbody .td:first-child:nth-last-child(1) {
        box-shadow: unset !important;
        border-left: 0 !important;
        border-right: 0 !important;

    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NswSearch.vue